(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["coupon-gallery-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const card = e.target.closest('.coupon-gallery__card[data-copy]');
    if (!card) return;
    navigator.clipboard?.writeText(card.dataset.copy).then(() => {
      card.classList.add('is-copied');
      setTimeout(() => card.classList.remove('is-copied'), 1800);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pincode-checker"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.currentScript && document.currentScript.previousElementSibling;
    // Use a general query so it survives placement order + customizer re-renders
    document.querySelectorAll('.pincode-checker').forEach(initPincodeChecker);

    function initPincodeChecker(el) {
      if (el.dataset.initialized === '1') return;
      el.dataset.initialized = '1';

      const input   = el.querySelector('.pincode-checker__input');
      const btn     = el.querySelector('.pincode-checker__btn');
      const error   = el.querySelector('.pincode-checker__error');
      const inputV  = el.querySelector('.pincode-checker__input-view');
      const resultV = el.querySelector('.pincode-checker__result-view');
      const etaEl   = el.querySelector('.pincode-checker__eta');
      const pinEl   = el.querySelector('.pincode-checker__pin');
      const change  = el.querySelector('.pincode-checker__change');

      const CSV_URL = 'https://cdn.shopify.com/s/files/1/0738/2469/8589/files/pincode_1.csv?v=1750156962';
      const STORAGE_KEY = 'wakeup_pincode';

      const saved = safeGet(STORAGE_KEY);
      if (saved && /^\d{6}$/.test(saved)) {
        input.value = saved;
        check();
      }

      input.addEventListener('input', () => {
        el.removeAttribute('data-error');
        error.hidden = true;
        btn.disabled = !/^\d{6}$/.test(input.value);
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && !btn.disabled) check();
      });

      btn.addEventListener('click', check);

      change.addEventListener('click', () => {
        el.setAttribute('data-state', 'idle');
        inputV.hidden = false;
        resultV.hidden = true;
        input.focus();
        input.select();
      });

      async function check() {
        const pin = input.value.trim();
        if (!/^\d{6}$/.test(pin)) return;

        btn.disabled = true;
        const originalLabel = btn.textContent;
        btn.textContent = 'Checking…';

        try {
          const days = await lookupDays(pin);
          if (days == null) {
            showError('This pincode is not serviceable.');
            return;
          }
          safeSet(STORAGE_KEY, pin);
          showSuccess(pin, days);
        } catch (err) {
          console.error('[pincode-checker]', err);
          showError('Could not check pincode. Please try again.');
        } finally {
          btn.disabled = false;
          btn.textContent = originalLabel;
        }
      }

      async function lookupDays(pin) {
        const res = await fetch(CSV_URL);
        if (!res.ok) throw new Error('CSV fetch failed: ' + res.status);
        const text = await res.text();
        const lines = text.split(/\r?\n/);
        for (let i = 0; i < lines.length; i++) {
          const parts = lines[i].split(',');
          if (parts[0] && parts[0].trim() === pin) {
            const d = parseInt((parts[1] || '').trim(), 10);
            return Number.isFinite(d) ? d : 3;
          }
        }
        return null;
      }

      function showSuccess(pin, days) {
        const low  = Math.max(1, days);
        const high = low + 1;
        etaEl.textContent = 'Once dispatched, delivery within ' + low + '-' + high + ' business days';
        pinEl.textContent = pin;
        el.setAttribute('data-state', 'success');
        inputV.hidden = true;
        resultV.hidden = false;
      }

      function showError(msg) {
        el.setAttribute('data-error', '1');
        error.textContent = msg;
        error.hidden = false;
      }

      function safeGet(k) { try { return localStorage.getItem(k); } catch (_) { return null; } }
      function safeSet(k, v) { try { localStorage.setItem(k, v); } catch (_) {} }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
